import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import paths from '../paths';
import CardBins from 'components/pages/payment/binRouting/CardBins/CardBins';
import { createRoute, createRoutes } from 'constants/utils';
import { NavigationTabLayout } from 'components/organism/TabGroups/NavigationTabLayout';

const Users = lazy(() => import('../../components/pages/admin/users/Users'));
const AddUser = lazy(() => import('../../components/pages/admin/users/AddUser/AddUser'));
const EditUser = lazy(() => import('../../components/pages/admin/users/EditUser/EditUser'));
const CopyUser = lazy(() => import('../../components/pages/admin/users/CopyUser/CopyUser'));
const Logs = lazy(() => import('../../components/pages/admin/logs/Logs'));
const Smtps = lazy(() => import('../../components/pages/admin/plugins/smtp/Smtps'));
const FulfilmentHouses = lazy(() => import('../../components/pages/admin/plugins/fulfilmentHouse/FulfilmentHouses'));
const AdminAffiliates = lazy(() => import('../../components/pages/admin/Affiliates/AdminAffiliates/AdminAffiliates'));
const EditAffiliate = lazy(() => import('../../components/pages/admin/Affiliates/EditAffiliate/EditAffiliate'));
const ScrubSettings = lazy(() => import('../../components/pages/admin/Affiliates/ScrubSettings/ScrubSettings'));
const Blacklists = lazy(() => import('../../components/pages/admin/blacklist/Blacklists'));
const Whitelists = lazy(() => import('../../components/pages/admin/whitelist/Whitelists'));
const TestCards = lazy(() => import('../../components/pages/admin/testCards/TestCards'));
const Roles = lazy(() => import('../../components/pages/admin/Roles/Roles'));
const AddRole = lazy(() => import('../../components/pages/admin/Roles/AddRole/AddRole'));
const EditRole = lazy(() => import('../../components/pages/admin/Roles/EditRole/EditRole'));

const affiliateTabs = [
  {
    name: 'Affiliates',
    value: 'default',
    path: paths.adminAffiliates,
  },
  {
    name: 'Scrub Settings',
    value: 'scrub',
    path: paths.scrubSettings,
  },
  {
    name: 'Prepaid BINS',
    value: 'prepaid',
    path: paths.prepaidBins,
  },
];

export const adminRoutes = (abilities) => {
  const routes = [
    (abilities?.settings?.role?.read ?? false) && createRoute(paths.roles, Roles),
    (abilities?.settings?.role?.write ?? false) && createRoute(paths.newRole, AddRole),
    (abilities?.settings?.role?.write ?? false) && createRoute(paths.editRole(), EditRole),
    (abilities?.settings?.user?.read ?? false) && createRoute(paths.users, Users),
    (abilities?.settings?.user?.write ?? false) && createRoute(paths.newUser, AddUser),
    (abilities?.settings?.user?.write ?? false) && createRoute(paths.editUser(), EditUser),
    (abilities?.settings?.user?.write ?? false) && createRoute(paths.copyUser(), CopyUser),
    (abilities?.settings?.logs?.read ?? false) && createRoute(paths.logs, Logs),
    ...createRoutes([{
      path: paths.plugins,
      children: [{
        path: paths.smtp,
        checkname: 'settings.smtp_account.read',
        component: Smtps,
      }, {
        path: paths.fulfilmentHouse,
        checkname: 'settings.fulfillment_house.read',
        component: FulfilmentHouses,
      }],
    }], abilities),
    ((abilities?.settings?.affiliate?.read ?? false) && {
      path: paths.affiliates,
      element: <NavigationTabLayout tabs={affiliateTabs} />,
      children: [{
        index: true,
        element: (
          <Navigate
            replace={true}
            to={paths.adminAffiliates}
          />
        ),
      },
      createRoute(paths.adminAffiliates, AdminAffiliates),
      createRoute(paths.scrubSettings, ScrubSettings),
      createRoute(paths.prepaidBins, CardBins, { prepaid: true }),
      ],
    }),
    (abilities?.settings?.affiliate?.write ?? false) && createRoute(paths.editAffiliate(), EditAffiliate),
    (abilities?.settings?.black_lists?.read ?? false) && createRoute(paths.blacklists, Blacklists),
    (abilities?.settings?.white_lists?.read ?? false) && createRoute(paths.whitelists, Whitelists),
    (abilities?.settings?.test_card?.read ?? false) && createRoute(paths.testCards, TestCards),
  ].filter(Boolean);

  const indexPath = routes.length > 0 ? routes[0].path : '/';

  return {
    path: paths.getAdminLayout,
    children: [
      {
        index: true,
        element: (
          <Navigate
            replace={true}
            to={indexPath}
          />
        ),
      },
      ...routes,
    ],
  };
};
